import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import useEvent from '@src/hooks/useEvent';
import { getEventTimeRange } from '@src/utils/event';

const EventTimeWrapper = styled.div`
	padding-bottom: 12px;
	border-bottom: 1px solid #F0F0F0;
	margin-top: 12px;

	@media ${props => props.theme.device.tablet} {
		padding-bottom: 16px;
		margin: 0;
	}

	@media ${props => props.theme.device.smTablet} {
		padding-bottom: 16px;
		margin: 0;
	}

	@media ${props => props.theme.device.mobile} {
		border-bottom: none;
		padding-bottom: 4px;
		margin: 0;
	}
`;

const InfoList = styled.ul`
	padding-inline-start: 8px;
	margin: 0;
	margin-inline-start: 8px;
`;

const InfoItem = styled.li`
	&:not(:last-child) {
		margin-bottom: 4px;
	}
`;

const InfoTitle = styled.span`
	margin-right: 4px;
	font-size: 12px;

	@media ${props => props.theme.device.desktop} {
		display: none;
	}

	@media ${props => props.theme.device.mobile} {
		font-size: 14px;
	}
`;

const InfoContent = styled.span`
	font-size: 14px;
	font-weight: 700;
	color: #333333;

	@media ${props => props.theme.device.mobile} {
		font-size: 16px;
	}
`;

interface IEventMain {
	className?: string;
}

const EventTime = ({ className }: IEventMain): JSX.Element => {
	const { t } = useTranslation();
	const { event: { location }, sortedEventSlots } = useEvent();

	return (
		<EventTimeWrapper className={className}>
			<InfoList>
				<InfoItem>
					<InfoTitle>{t('event:event_time')}</InfoTitle>
					<InfoContent>
						{getEventTimeRange({ sortedEventSlots, t })}
					</InfoContent>
				</InfoItem>
				<InfoItem>
					<InfoTitle>{t('event:event_location')}</InfoTitle>
					<InfoContent>{location}</InfoContent>
				</InfoItem>
			</InfoList>
		</EventTimeWrapper>
	);
};

export default EventTime;
